import React, { useEffect, useState } from "react";
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import { useAppDispatch, useAppSelector } from "../../useStore";
import swal from "sweetalert";
import TranningTable from "../Applicants/ApplicantTableComponent/TranningTable";

const Tranning = () => {
	const [resetID, setResetID] = useState(false)
	const dispatch = useAppDispatch();

	const {
		EvalvationisSuccess,
		UpdateScreeningStatusisSuccess,
		sendOfferisSuccess,
		applicationInterviewisSuccess,
		updateApplicationInterviewStatusisSuccess,
		sendEmailisSuccess,
		shareApplicationisSuccess,
		ScreeningisSuccess,
		applicationassignedisSuccess,
		scheduleApplicantisSuccess,
		updateInterviewStatusisSuccess,
		UpdateOfferisSuccess,
		sendForHireisSuccess,
		EditapplicantionisSuccess,
		sendForTranningisSuccess,
		updateTranningisSuccess,
		data,
		isError,
		isLoading,
		message,
	} = useAppSelector((state: { applicant: any }) => state.applicant);

	useEffect(() => {
		if (
			EvalvationisSuccess ||
			UpdateScreeningStatusisSuccess ||
			sendOfferisSuccess ||
			applicationInterviewisSuccess ||
			updateApplicationInterviewStatusisSuccess ||
			sendEmailisSuccess ||
			shareApplicationisSuccess ||
			ScreeningisSuccess ||
			applicationassignedisSuccess ||
			scheduleApplicantisSuccess ||
			updateInterviewStatusisSuccess ||
			UpdateOfferisSuccess ||
			sendForHireisSuccess ||
			EditapplicantionisSuccess ||
			sendForTranningisSuccess ||
			updateTranningisSuccess
		) {
			const input = { applicationStatus: "TRAINING" };
			// @ts-ignore 
			dispatch(getallapplicant(input))

			setTimeout(() => {
				dispatch(reset());
			}, 2000);
		}
	}, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, dispatch, UpdateOfferisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);





	useEffect(() => {
		const input = { applicationStatus: "TRAINING" };
		// @ts-ignore 
		dispatch(getallapplicant(input))

	}, [dispatch]);

	useEffect(() => {
		if (isError) {
			swal({
				title: "error",
				text: message,
				icon: "error"
			})
			dispatch(reset())
		}
	}, [dispatch, isError, message])




	return (
		<div>
			<TranningTable
				pageHeader={"Tranning"}
				Status={"Tranning"}
				headerTitles={[
					"",
					"Edit",
					"Update Tranning",
					"Applicant Name",
					"Gender",
					"Date Of Birth",
					"Job Profile",
					"View ID",
					"Applied on",
					"View Certificate",
					"Email",
					"Phone Number",
					"Average Interview Score",
					"Work Experience",
					"Relevant Work Experience",
					"Location",
					"Edit",
                    "Date of Completion"
				]}
				data={data}
				message={message}
				isError={isError}
				isLoading={isLoading}
				setResetID={setResetID}
			/>
		</div>
	);
};

export default Tranning;
